import { render, staticRenderFns } from "./FormLabelItem.vue?vue&type=template&id=73872a43&scoped=true"
import script from "./FormLabelItem.vue?vue&type=script&lang=js"
export * from "./FormLabelItem.vue?vue&type=script&lang=js"
import style0 from "./FormLabelItem.vue?vue&type=style&index=0&id=73872a43&scoped=true&lang=css"
import style1 from "./FormLabelItem.vue?vue&type=style&index=1&id=73872a43&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73872a43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73872a43')) {
      api.createRecord('73872a43', component.options)
    } else {
      api.reload('73872a43', component.options)
    }
    module.hot.accept("./FormLabelItem.vue?vue&type=template&id=73872a43&scoped=true", function () {
      api.rerender('73872a43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/formItems/FormLabelItem.vue"
export default component.exports